/* Astaxanthin Amavil landing — interactions (robust, event-delegated) */
(function () {
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  /* ---- Horizontal carousels (benefits / stories / reasons) via arrow buttons ---- */
  function scrollByCard(track, dir){
    if(!track) return;
    var first = track.querySelector(':scope > *');
    var step = first ? first.getBoundingClientRect().width + 18 : track.clientWidth * 0.85;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-axt-carr]');
    if(!btn) return;
    var wrap = btn.closest('[data-axt-carrwrap]') || document;
    var track = wrap.querySelector('[data-axt-track]');
    scrollByCard(track, btn.getAttribute('data-axt-carr') === 'next' ? 1 : -1);
  });

  /* ---- Product gallery: arrows + thumbnails ---- */
  function initGallery(section){
    var track = section.querySelector('[data-axt-gtrack]');
    if(!track) return;
    var slides = track.querySelectorAll('.axt-gslide');
    var thumbs = section.querySelectorAll('.axt-thumb');
    if(!slides.length) return;
    function go(i){
      i = Math.max(0, Math.min(slides.length-1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior:'smooth' });
    }
    function current(){
      var sc = track.scrollLeft, best=0, bd=Infinity;
      slides.forEach(function(s,i){ var d=Math.abs(s.offsetLeft-track.offsetLeft-sc); if(d<bd){bd=d;best=i;} });
      return best;
    }
    section.querySelectorAll('.axt-garrow').forEach(function(a){
      a.addEventListener('click', function(){ go(current() + (a.classList.contains('next')?1:-1)); });
    });
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ go(i); }); });
    track.addEventListener('scroll', function(){
      var c = current();
      thumbs.forEach(function(t,i){ t.classList.toggle('is-active', i===c); });
    }, { passive:true });
  }

  /* ---- "Beneficios respaldados" accordions (max-height) ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-axt-rb]');
    if(!btn) return;
    var row = btn.closest('.axt-rb');
    if(!row) return;
    var open = row.classList.toggle('is-open');
    btn.textContent = open ? '–' : '+';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- Sticky bar: hidden on load, show past hero, hide on footer ---- */
  function initSticky(){
    var bar = document.querySelector('[data-axt-sticky]');
    if(!bar) return;
    var buy = document.querySelector('[data-axt-buy]') || document.getElementById('axt-hero');
    var footer = document.querySelector('.footer, footer, [data-axt-footer]');
    var target = bar.getAttribute('data-axt-scrollto') || '#axt-buy';
    var btn = bar.querySelector('.axt-sticky-btn');
    if(btn){ btn.addEventListener('click', function(){
      var el = document.querySelector(target) || buy;
      if(el){ el.scrollIntoView({ behavior:'smooth', block:'start' }); }
    }); }
    function onScroll(){
      var show = false;
      if(buy){
        var r = buy.getBoundingClientRect();
        show = r.bottom < 0; // hero scrolled out
      } else {
        show = window.scrollY > window.innerHeight * 0.5;
      }
      if(footer){
        var fr = footer.getBoundingClientRect();
        if(fr.top < window.innerHeight - 20) show = false;
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    onScroll();
  }

  /* ---- Counters (results) ---- */
  function initCounters(){
    document.querySelectorAll('[data-axt-counters]').forEach(function(sec){
      var nums = sec.querySelectorAll('[data-axt-count]');
      if(!nums.length) return;
      var started = false;
      function run(){
        if(started) return; started = true;
        var start = performance.now(), dur = 1700;
        function step(t){
          var k = Math.min(1,(t-start)/dur), e = 1-Math.pow(1-k,3);
          nums.forEach(function(n){ var tgt = parseInt(n.getAttribute('data-axt-count'),10)||0; n.firstChild ? n.childNodes[0].nodeValue = Math.round(tgt*e) : n.textContent = Math.round(tgt*e); n.setAttribute('data-cur', Math.round(tgt*e)); });
          if(k<1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ run(); io.disconnect(); } }); }, { threshold:0.3 });
        io.observe(sec);
      } else { run(); }
    });
  }

  /* ---- Countdown (oferta) ---- */
  function initCountdown(){
    document.querySelectorAll('[data-axt-countdown]').forEach(function(box){
      var hEl=box.querySelector('[data-cd-h]'), mEl=box.querySelector('[data-cd-m]'), sEl=box.querySelector('[data-cd-s]');
      if(!hEl) return;
      var deadline = Date.now() + (7*3600+32*60+15)*1000;
      function p(n){ return String(n).padStart(2,'0'); }
      function tick(){
        var d = Math.max(0, deadline - Date.now());
        hEl.textContent = p(Math.floor(d/3600000));
        mEl.textContent = p(Math.floor(d%3600000/60000));
        sEl.textContent = p(Math.floor(d%60000/1000));
      }
      tick(); setInterval(tick, 1000);
    });
  }

  ready(function(){
    document.querySelectorAll('[data-axt-gallery]').forEach(initGallery);
    initSticky();
    initCounters();
    initCountdown();
    // ensure landing videos buffer + play
    document.querySelectorAll('.axt-sec video').forEach(function(v){ try{ v.muted=true; v.play&&v.play().catch(function(){}); }catch(e){} });
  });
})();
